var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderContributionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 013.5 19V5c0-.55.196-1.02.588-1.412A1.93 1.93 0 015.5 3h4.175c.183-.583.542-1.062 1.075-1.437A2.986 2.986 0 0112.5 1a3 3 0 011.788.563c.525.375.88.854 1.062 1.437h4.15c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v14c0 .55-.196 1.021-.587 1.413A1.92 1.92 0 0119.5 21h-14zm0-2h14V5h-2v2a.968.968 0 01-.288.713A.964.964 0 0116.5 8h-8a.965.965 0 01-.712-.288A.972.972 0 017.5 7V5h-2v14zm7-14a.968.968 0 00.713-.288A.964.964 0 0013.5 4a.973.973 0 00-.288-.712A.965.965 0 0012.5 3a.965.965 0 00-.712.288A.973.973 0 0011.5 4c0 .283.095.52.288.713A.96.96 0 0012.5 5z",
    fill: "#CDCDCD"
  })));
}

export default SvgHeaderContributionIcon;